import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSalaAuth } from '../auth/SalaAuthContext';

/**
 * `/` — solo redirección si hay sesión.
 * El hero visual vive en LandingLayout (persistente).
 */
export function HomePage() {
  const { user, profileComplete, loading } = useSalaAuth();

  if (!loading && user) {
    return (
      <Navigate
        to={profileComplete ? '/studio' : '/onboarding?returnTo=%2Fstudio'}
        replace
      />
    );
  }

  return null;
}
